// Warnings printed across the entire bottom of each item's row.
// These are things like messages about coupon being not valid for this item.
import React from "react";
import {isEmpty, camelCase, reject} from "lodash";
import clsx from "clsx";

export default function CartItemMessages({shoppingCart, item = {}, currentAgent, ...props}) {
  let warnings = [...(item.warnings || [])];

  if (!currentAgent) {
    warnings =  reject(warnings, w => (w.flavour || "").startsWith("agent"))
  }

  if (isEmpty(warnings)) {
    return null;
  }

  return <>
    {warnings.map((w, i) => <CartItemMessage key={i} warning={w}/>)}
  </>
}

const MESSAGE_CLASSES = {
  noneAllowed: 'text-gray-600',
  maxDiscount: 'text-gray-600',
  salePromo: 'uppercase text-brand-orange font-bold',
  agent: 'text-agent-purple underline border-agent-purple font-bold text-right',
  default: 'text-gray-600'
}

function CartItemMessage({warning}) {
  if (!warning) return null;

  const message = warning.message ? warning.message : warning.toString();
  const flavour = camelCase(warning.flavour || 'default');
  const agentMessage = flavour.startsWith('agent')
  let flavourClasses = MESSAGE_CLASSES[flavour] ||
    (agentMessage ? MESSAGE_CLASSES.agent : MESSAGE_CLASSES.default);

  // flavours: max_discount none_allowed
  const className = clsx([
    "text-md p-2",

    (MESSAGE_CLASSES[flavour] ||
      (agentMessage ? MESSAGE_CLASSES.agent : MESSAGE_CLASSES.default))
  ]);

  return <div className={className}>
    {agentMessage && <span className="">
      <span className="fa fa-user-secret mr-2"/>
    </span>}

    {message}
  </div>
}
